export const REACT_APP_PUBLIC_API_TOKEN =
  "11b623f7-cb76-4130-a7d5-ba24eb1590d6";
export const REACT_APP_API_HOST_IP = "https://api-staging.q-u-i-l-t.com/";
export const REACT_APP_IS_GAME_CODE = false;
